"use strict";
exports.__esModule = true;
exports.toCamelCase = void 0;
var toCamelCase = function camalize(str) {
    return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) { return chr.toUpperCase(); });
};
exports.toCamelCase = toCamelCase;
